import styled from "styled-components";

const closeButtonPosition = 18;
export const Container = styled.div`
    padding: 32px 20px 20px;
`;

export const CvvInputContainer = styled.div`
    margin-top: 30px;
`;

export const CvvInputSubmitCTA = styled.div`
    margin-top: 20px;
`;

export const CloseButton = styled.div`
    position: absolute;
    top: ${closeButtonPosition}px;
    right: ${closeButtonPosition}px;
`;

export const CvvContainerTitle = styled.div`
    display: flex;
`;
